export default {
  noFund: '无内部转账记录',
  fund_transefer: '内部转账',
  from_account: '扣款账户',
  to_account: '收款账户',
  to_currency: '扣款货币',
  balance: '可转账金额',
  error_transfer_check: '还有未处理的转账订单',
  success: '您的转账申请已成功提交,如有问题请与我们联系',
  sameOutAndIn: '您的转出和转入账号重复,请重新选择,如有问题请与我们联系',
  transefer_amount: '转账金额',
  validate: {
    max: '转账金额不得大于对应币种可转账金额',
    maxMt5: '转账金额不得大于可用预付款',
    min: '转账金额不得小于0.01',
    pinyinName: '请输入姓名拼音',
    correctAmount: '请输入正确的金额'
  },
  info_dialog: {
    application_number: '您的申请编号是',
    reminder: '我们会尽快处理您的申请，您可以拨打+852 2655 0338 / 400 120 0068（中国内地免费热线）与我们联系！',
    submitSuccess: '提交成功'
  },
  balanceLow: '没有余额',
  acceptableAmount: '建议最大可转账金额',
  largestAmount: '为降低转账后账户资金紧张而短期内出现强制平仓的风险，此为建议最大转账金额。同时，转账之金额不可大于账户「可用保证金」金额。',
  transferInterTip: `
    1. 内部转账支持7×24小时全天候办理。对于未能实时顺利办理的申请，将由专人于工作日办公时间内跟进处理。 <br/>
    2. 结单显示规则 <br/>
    （以下均为香港时间） <br/>
    <span style="color:#333;font-weight:500;">(I) 证券/基金账户：</span>客户于每日16:59或之前办理完成的内部转账将反映在当日的结单；其后完成的内部转账将显示在下一交易日的结单。 <br/>
    <span style="color:#333;font-weight:500;">(II) 期货账户：</span>客户于星期一至五（元旦除外）06:00至翌日05:59期间办理完成的内部转账将反映在当日的结单；于星期六05:59后办理完成的申请将显示在下一交易日的结单。 <br/>
    备注：若内部转账于每年元旦当日办理完成，相关记录将显示在下一交易日的结单。 <br/>
    <span style="color:#333;font-weight:500;">(III) 杠杆式外汇账户：</span> <br/>
    <span style="color:#333;font-weight:500;">美东夏令时间：</span> <br/>
    星期一至五05:05至翌日04:55期间办理完成的内部转账将反映在当日的结单；于星期六04:55后办理完成的内部转账将显示在下一交易日的结单。 <br/>
    <span style="color:#333;font-weight:500;">美东冬令时间：</span> <br/>
    星期一至星期五当日06:05至翌日05:55期间办理完成的内部转账将反映在当日的结单；于星期六05:55后办理完成的内部转账将显示在下一交易日的结单。`
}
